import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private storage: StorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isAuthenticated = this.storage.getFromCookie('access_token');
      if (isAuthenticated) {
            // logged in so return true
          console.log('logged in');
            return true;
        } else {
          const navigation = this.router.getCurrentNavigation();
          let url = 'overview';
          if (navigation) {
            url = navigation.extractedUrl.toString();
          }
          this.router.navigate(['login'], { queryParams: { returnUrl: url }});
          return false;
        }

        // not logged in so redirect to login page with the return url and return false
        
    }
  
}
